import React from 'react';
import {
	TRANSPARENT,
	asText,
	formatCountdownTarget,
	formatUnitLabel,
	resolveCountdownColor,
	resolveCountdownTarget,
	resolveCountdownVariant,
} from 'components/Widgets/countdown/countdown';
import useCountdown from 'components/Widgets/countdown/useCountdown';
import './CountdownPreview.scss';

const PALETTE_UNITS = ['04', '16'];

const COLOR_VARIABLES = {
	digitColor: '--countdown-digit',
	labelColor: '--countdown-label',
	backgroundColor: '--countdown-background',
	tileColor: '--countdown-tile',
	accentColor: '--countdown-accent',
};

const CountdownPalettePreview = () => (
	<div className="countdown-palette">
		{PALETTE_UNITS.map((digits, index) => (
			<React.Fragment key={digits}>
				{index > 0 && <span className="countdown-palette-separator">:</span>}
				{digits.split('').map((digit, position) => (
					<span className="countdown-palette-tile" key={position}>
						{digit}
					</span>
				))}
			</React.Fragment>
		))}
	</div>
);

const CountdownValue = ({ variant, value }) =>
	variant === 'flip' ? (
		<div className="countdown-value">
			{String(value)
				.padStart(2, '0')
				.split('')
				.map((digit, position) => (
					<span className="countdown-tile" key={position}>
						{digit}
					</span>
				))}
		</div>
	) : (
		<div className="countdown-value">{value}</div>
	);

const CountdownUnits = ({ variant, units }) => (
	<div className="countdown-units">
		{units.map(({ unit, value }) => (
			<div className="countdown-unit" key={unit}>
				<CountdownValue variant={variant} value={value} />
				<span className="countdown-unit-name">{formatUnitLabel(unit, value)}</span>
			</div>
		))}
	</div>
);

const CountdownPreview = ({ from, item, event, margin }) => {
	const widgetProps = item?.props || {};
	const targetMs = resolveCountdownTarget(widgetProps);
	const countdown = useCountdown(targetMs);

	if (from === 'WidgetButton') {
		return (
			<div className="WidgetPreviews">
				<CountdownPalettePreview />
			</div>
		);
	}

	const variant = resolveCountdownVariant(widgetProps);
	const colorVariables = Object.fromEntries(
		Object.entries(COLOR_VARIABLES).map(([prop, variable]) => [
			variable,
			resolveCountdownColor(widgetProps, prop),
		])
	);
	const { titlePosition, showTargetTime } = widgetProps;
	const title = asText(widgetProps.title);
	const endMessage = asText(widgetProps.endMessage);
	const transparentBackground = colorVariables['--countdown-background'] === TRANSPARENT;
	const titleBelow = titlePosition === 'below';
	const titleElement = title && (
		<div className={`countdown-title countdown-title-${titleBelow ? 'below' : 'above'}`}>
			{title}
		</div>
	);

	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Countdown</div>}
				<div
					className={`countdown-preview countdown-${variant}${
						transparentBackground ? ' countdown-transparent' : ''
					}`}
					style={{ ...colorVariables, margin }}
				>
					{!titleBelow && titleElement}
					{countdown ? (
						<CountdownUnits variant={variant} units={countdown.units} />
					) : (
						<div className="countdown-empty">Set a date to count down to</div>
					)}
					{countdown?.mode === 'ended' && endMessage && (
						<div className="countdown-end-message">{endMessage}</div>
					)}
					{titleBelow && titleElement}
					{showTargetTime && targetMs !== null && (
						<div className="countdown-caption">{formatCountdownTarget(event, targetMs)}</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default CountdownPreview;
